import React, { HtmlHTMLAttributes, ImgHTMLAttributes, ReactElement, ReactNode, SyntheticEvent, useState } from "react";

export function Image(props: ImgHTMLAttributes<HTMLImageElement> & {fallback?: ReactElement, checkImg?:(img:HTMLImageElement)=>boolean}){
    const [error, setError] = useState(false)
    if(error)
        return props.fallback;

    function load(e:SyntheticEvent<HTMLImageElement>){
        if(props.checkImg && !props.checkImg(e.currentTarget)){
            setError(true);
        }
    }

    return <img {...props} onError={() => setError(true)} onLoad={load} />
}